/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsClockArrowRight: {
  name: 'clock-arrow-right';
  data: string;
} = {
  name: 'clock-arrow-right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM8 .5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Zm0 3a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8a.5.5 0 0 1-.5-.5V4a.5.5 0 0 1 .5-.5Zm3.646 9.146a.5.5 0 0 1 .707 0l1 1a.5.5 0 0 1 0 .707l-1 1a.5.5 0 0 1-.707-.707l.147-.146H3a.5.5 0 0 1 0-1h8.793l-.146-.146a.5.5 0 0 1 0-.707Z" fill="currentColor"/></svg>`,
};
